import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_scroll } from "../../state/scrollSlice";

const Cats = ({ categories }) => {
	const [cats, setCats] = useState(null);
	const dispatch = useDispatch();
	const scroll = useSelector((state) => state.scroll.value);
	const [show, setShow] = useState(false);

	useEffect(() => {
		if (scroll !== null) setCats(scroll);
	}, [scroll]);

	const scrollCategory = (id) => {
		dispatch(add_scroll(id));
		setShow(false);
	};
	return (
		<div className="containe">
			<input type="checkbox" id="toggle" checked={show} onChange={() => {}} />
			<label
				className="bubble"
				htmlFor="toggle"
				onClick={() => setShow((s) => !s)}
			>
				<i className="fa-solid fa-book"></i> &nbsp; menu
			</label>

			<nav className="nav">
				<ul>
					{categories.map((c) => {
						return (
							<span
								key={c.id}
								onClick={scrollCategory.bind(this, c.id)}
								className={`${
									cats === c.id
										? "littleline1 menucolor menupop"
										: "menucolor menupop"
								}`}
							>
								{c.name}
								<p>{c.dishes.length}</p>
							</span>
						);
					})}
				</ul>
			</nav>
		</div>
	);
};

export default Cats;
